import { EShowTariffType } from './UploadBigFileDialog.types';

export const choiceTariff = ({ isUsualTariffUser, isTrialUser, isOverQuota, showProTariff }): EShowTariffType => {
    // Триал показываем если пользователь не в оверквоте и не загружает файл больше 32гб
    if (isTrialUser && !isOverQuota && !showProTariff) {
        return EShowTariffType.TRIAL;
    }

    // Показываем про если пользователь с обычным тарифом
    // Или если любой пользователь заливает файл больше 32гб
    if (isUsualTariffUser || showProTariff) {
        return EShowTariffType.PRO;
    }

    return EShowTariffType.USUAL_TARIFF;
};
